import firebase from 'firebase/app'
import "firebase/auth"
import "firebase/storage"
import "firebase/firestore"

const firebaseConfig = {
    apiKey: "AIzaSyD118x__giFozGwiyuhalOnedObPhcKicE",
    authDomain: "agendalizate.firebaseapp.com",
    projectId: "agendalizate",
    storageBucket: "agendalizate.appspot.com",
    messagingSenderId: "300582122288",
    appId: "1:300582122288:web:25129a9607f7466cba0ef5"
};
/*

    apiKey: "AIzaSyBJ9q2TQ3q0PMhgbtox31e4gadatXyNNeI",
    authDomain: "sofymeet.firebaseapp.com",
    projectId: "sofymeet",
    storageBucket: "sofymeet.appspot.com",
    messagingSenderId: "1079588859854",
    appId: "1:1079588859854:web:e7709a48a30fa496a3459f"
*/

firebase.initializeApp(firebaseConfig)

export const fb = firebase;
export const  db = firebase.firestore()
export const auth = firebase.auth()
export const marcadetiempo = firebase.firestore.FieldValue.serverTimestamp;
export const storage = firebase.storage()